import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row g-3" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexDropzone',
  setup(__props) {

const DefaultDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/DefaultDropzone.vue"))
const ImageDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/ImageDropzone.vue"))
const SingleDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/SingleDropzone.vue"))
const MultiDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/MultiDropzone.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      mains: "Dropzone",
      title: "Dropzone"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(DefaultDropzone)),
        _createVNode(_unref(ImageDropzone)),
        _createVNode(_unref(SingleDropzone)),
        _createVNode(_unref(MultiDropzone))
      ])
    ])
  ], 64))
}
}

})